import { useQuery } from '@tanstack/react-query'

import { StorePersistKeys } from 'src/types'

import { getAllMaintenanceHistory } from 'src/api/Maintenance'

export const useGetAllMaintenanceByCarNumber = (carNumber: string) => {
  return useQuery({
    queryKey: [StorePersistKeys.MAINTENANCE_HISTORY, carNumber],
    queryFn: () => getAllMaintenanceHistory(carNumber),
    enabled: Boolean(carNumber),
  })
}
